.du{width:max-content;}